import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo'
})
export class TimeAgoPipe implements PipeTransform {

  transform(value: string | Date): string {
    if (!value) return '';

    // Server sends naive datetime strings (no 'Z' / no offset). new Date()
    // interprets those as local time, which creates an 8-hour offset for
    // UTC+8 clients (e.g. Philippines). Treat naive strings as UTC so the
    // displayed "X hours ago" matches the server's intent.
    let date: Date;
    if (typeof value === 'string' && !/[Zz]|[+-]\d{2}:?\d{2}$/.test(value.trim())) {
      date = new Date(value + 'Z');
    } else {
      date = new Date(value);
    }
    const timestamp = date.getTime();
    const now = new Date().getTime();
    const diffMs = now - timestamp;
    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 60) return `${seconds} seconds ago`;
    if (minutes < 60) return `${minutes} minutes ago`;
    if (hours < 24) return `${hours} hours ago`;
    if (days === 1) return 'Yesterday';
    return `${days} days ago`;
  }

}
